import React, { useEffect,useState,useRef } from 'react'
import {Container,Row} from 'react-bootstrap'
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import {useDispatch,useSelector} from 'react-redux'
import { getSingleEvent, update,clearError } from '../../../redux/reducers/eventSlice';
import { useParams,useNavigate } from 'react-router-dom';
import inputErrors from '../../helpers/validation'
import dayjs from 'dayjs';
import {snackbarContext} from '../../helpers/Snakbar'
import MapInput from './MapInput';
import { clearUser } from '../../../redux/reducers/authSlice';
import Navbar from '../../helpers/Navbar';
import { TabTitle } from '../../helpers/GeneralFunctions';
import Loader from '../../helpers/Loader';
import Footer from '../../helpers/Footer';

const EVENT_DETAILS_FIELDS = [
    "eventName",
    "eventDate",
    // "eventTime",
    "eventTheme",
    "eventAddress",
    "eventInfo"
];

const UpdateEvent = () => {
   const formRef = useRef(null);
  TabTitle("Update Event")
  const setStateSnackbarContext=React.useContext(snackbarContext)
  const {user}=useSelector((state)=>state.auth)
  const now = new Date().getTime();
const expiryTime = new Date(user && user.demoExpiryTime).getTime();
const isDemoExpired = user && user.demoVersion && expiryTime && now > expiryTime;
const isInviteExpired= user && user.inviteTimeExpired
  const [showEventDateWarning, setShowEventDateWarning] = useState(false);
  const {id} =useParams()
   const dispatch=useDispatch()
   const navigate=useNavigate()
   const {eventDetail,loading,error:backendError}=useSelector((state)=>state.event)
   const [values,setValues]=useState({
    eventName:" ",
    eventDate:eventDetail.eventDate,
    eventTime:" ",
    eventTheme:" ",
    eventInfo:" ",
    eventAddress:" ",
    group: [],
    gLocation:{}
   })
   const [isSubmitting, setSubmitting] = useState(false);
   const [errors, setErrors] = useState({});
   const [time,setTime]=useState(dayjs('2023-04-17T12:00'))
   const [showMapInput,setshowMapInput]=useState(false)
 
  const handleChange=(event)=>{
    setValues({
        ...values,
        [event.target.name]: event.target.value
      });    

      if (event.target.name === "eventDate") {
    setShowEventDateWarning(false);
  }
}

if(isDemoExpired){
  navigate("/")
}

if(isInviteExpired){
  navigate("/")
}



  const handleTimeChange=(newTime)=>{
    const hours = dayjs(newTime).format('hh:mm A');
    setValues(() => ({
      ...values,
      eventTime:hours
   }));

  }

  const getConvertedTime=()=>{
    return dayjs(eventDetail.eventTime,'hh:mm A')
  }

  const getConvertedDate=()=>{
    const date=dayjs(eventDetail.eventDate)
    const formattedDate=date.format("YYYY-MM-DD")
    return formattedDate
  }


  const updateEvent=async()=>{
    setSubmitting(false)
     dispatch(update({id,values,navigate,setStateSnackbarContext}))
  }

  useEffect(()=>{
    dispatch(getSingleEvent(id))
  },[id])
  useEffect(()=>{
    if(isSubmitting){
      const noErrors = Object.keys(errors).length === 0;   
      if(noErrors){
        updateEvent()
      }else{
        formRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  },[isSubmitting,errors])

  useEffect(()=>{

    if (backendError === "session expired" || backendError==="pls login to acess the resource") {
      setStateSnackbarContext(true, "session expired please login again", "error");
      dispatch(clearError());
      dispatch(clearUser())
      navigate("/login")
    }else if(backendError==="Event not found"){
        navigate("/display/notfound")
    }else if (backendError) {
      setStateSnackbarContext(true, backendError, "error");
      dispatch(clearError());
    }
  },[backendError])

  useEffect(()=>{
   setValues({
    eventName:eventDetail.eventName,
    eventTheme:eventDetail.eventTheme,
    eventInfo:eventDetail.eventInfo,
    eventAddress:eventDetail.eventAddress,
    eventDate:getConvertedDate(),
    gLocation:eventDetail.gLocation,
   group: eventDetail.group || [],
   })
   setTime(getConvertedTime())
  },[eventDetail])

  if(user && user.hasEnded){
    navigate("/display/notfound")
    }

  const handleSubmit=(e)=>{
    e.preventDefault()
    const validationErrors = inputErrors(
            values,
            EVENT_DETAILS_FIELDS
        );

    setErrors(validationErrors)
        if (Object.keys(validationErrors).length > 0) {
                 return
               }

    if(user.demoVersion && values.eventDate < user.demoExpiryTime){
     setShowEventDateWarning(true); return; 
    }
   setSubmitting(true)
  }

  
 
    const renderTrialDateWarning = (selectedDate) => {
  if (!selectedDate || !user?.demoExpiryTime) {
    return null;
  }

  const trialExpiry = new Date(user?.demoExpiryTime);
  const selected = new Date(selectedDate);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
    });
  };

  return (
    <div className="trial-date-warning">
      <div className="trial-date-warning-icon">
        ⓘ
      </div>

      <div className="trial-date-warning-content">

        <div className="trial-date-warning-title">
          This date is within the trial period.
        </div>

        <div className="trial-date-warning-text">
          Your free trial ends on{" "}
          <strong>{formatDate(trialExpiry)}</strong>.
        </div>

        <div className="trial-date-warning-text">
          To use <strong>{formatDate(selected)}</strong>, upgrade your invite.
        </div>

        <div className="trial-date-warning-hint">
          You can continue your trial by choosing a date after{" "}
          {formatDate(trialExpiry)}.
        </div>

      </div>
    </div>
  );
};

  const handleRemoveLocation = () => {
  setValues((prev) => ({
    ...prev,
    gLocation: {}
  }));
  setshowMapInput(false);
};

  return (
    <>
    <Navbar/>
    {loading?<Loader/>:<Container >
    <Row  className='justify-content-center px-2'>
    <div className={`col-lg-8 col-md-11 event-container ${user&& user.demoVersion?"demo-e-padding":"e-normal-padding"}`}>
    <h3 className='event-form-heading'>Edit Event</h3>
    
    <form onSubmit={handleSubmit} className='event-form' ref={formRef}>
    <div className={errors.eventName?"input-div-error":"input-div"}  >
    <input type="text"
     name="eventName" 
     value={values.eventName}
     onChange={handleChange}
     placeholder=' ' 
     className='input-field' />
    <label>Event name <span style={{color:"red"}}> * </span>  <span className='label-hide'>[ e.g. Reception ]  </span></label>
    </div>
    <div className='mb-3'>  {errors.eventName && (<small className="error-msg">{errors.eventName}</small>)} </div>
 
     {/* <div className='row align-items-center date-time-container'> */}
       <span className='event-label-text'>Event Date <span style={{ color: "red" }}> * </span> </span>
     {/* <div className="col-sm-6"> */}
      <input
        type="date"
        id="datePicker"
        name='eventDate'
        value={values.eventDate}
        onChange={handleChange}
         required
        className='date-input'
      />
      {/* </div> */}
      <div >  {errors.eventDate && (<small className="error-msg">{errors.eventDate}</small>)} </div>
       {showEventDateWarning &&  <div style={{marginTop:"10px"}}>{renderTrialDateWarning(values.eventDate)}</div> }
     {/* <div className='col-sm-6'> */}
      <span className='event-time-text'>Event Time <span style={{ color: "red" }}> * </span></span>
    <LocalizationProvider dateAdapter={AdapterDayjs}  >
      <DemoContainer components={['TimePicker']}  className="time-container">
        <TimePicker
         label="Event time" 
         className='time-input' 
         name="eventTime" 
         value={time} 
         onChange={handleTimeChange}
         />
      </DemoContainer>
    </LocalizationProvider> 
    <div className='mb-3'>  {errors.eventTime && (<small className="error-msg">{errors.eventTime}</small>)} </div>
    {/* </div> */}
   
    {/* </div> */}

         <div  className={errors.eventAddress?"input-div-error":"input-div"}>
     <input type="adress" 
     className='input-field' 
     name="eventAddress" 
     value={values.eventAddress}
     onChange={handleChange}
       placeholder=' ' />
     <label>Venue Name(Optional) <span className='label-hide'>(e.g. Shagun Palace)</span></label>     
     </div>
     <div className='mb-3'>  {errors.eventAddress && (<small className="error-msg">{errors.eventAddress}</small>)} </div>


     <div className={errors.eventTheme?"input-div-error":"input-div"} >
     <input type="text" 
      placeholder=' ' 
      name="eventTheme" 
      value={values.eventTheme}
      onChange={handleChange}
      className='input-field' />
     <label>Dress Code (Optional) <span className='label-hide'>(e.g. Black Kurta, Pink Saree)</span></label>     
     </div>
     <div>  {errors.eventTheme && (<small className="error-msg">{errors.eventTheme}</small>)} </div>

        <span className='event-details-text'>Event Details (Optional)</span>
     <textarea
      name="eventInfo" 
      className={errors.eventInfo?"textarea-error":"info-textarea"}
      value={values.eventInfo}
       cols="30" 
       rows="3" 
       onChange={handleChange}
       placeholder=' Add any other information for your guests'></textarea>
       <div className='mb-3'>  {errors.eventInfo && (<small className="error-msg">{errors.eventInfo}</small>)} </div>
       
         <div className="google-map-new-conatiner">
          <label>Event Location:</label>  
             <span className="location-info">
             Search and select the event location so guests can get directions from your invitation.
  </span> 
           {/* <p className="location-name">{values?.gLocation?.place_name}</p> */}

            <p className="location-name">
    {values?.gLocation?.place_name ? values.gLocation.place_name : "No location added"}
  </p>
         
          {!showMapInput && (
  <div className="location-btn-group">

    <button
      type="button"
      onClick={() => setshowMapInput(true)}
      className="change-location-btn"
    >
     {values?.gLocation?.place_name ? "Change Location" : "Add Location"}
    </button>

    {values?.gLocation?.place_name && (
      <button
        type="button"
        onClick={handleRemoveLocation}
        className="remove-location-btn"
      >
        Remove 
      </button>
    )}

  </div>
)}
         

         </div>
          {showMapInput ? 
          <>
           <MapInput values={values} setValues={setValues} update="true" />
            <span className='google-location-heper-text'>Can't find the place? Use <GpsFixedIcon/> for current location</span>
             {/* <span className="location-helper">(Search a venue and tap submit to update. Don’t paste anything here)</span> */}
           </>
           :""  }
      
      
     <button className='event-submit-button' type='submit'>Update Event</button>
     </form>
     </div>
     </Row>
     </Container>}
     <Footer userCode={user&&user.userCode}/>
    </>
  )
}

export default UpdateEvent